import {
  useCreateFormDataMutation,
  useGetFormLibraryMutation,
  useGetPatientToolkitFormByIdMutation,
  useSelecteToolkitFormDataMutation,
  useSignToolkitFormMutation,
  useUpdateToolkitFormDataMutation
} from 'src/services/toolkitForms';

export const useToolKitForms = () => {
  const [
    createToolkitFromDataFunc,
    {
      isError: createToolkitFromDataIsError,
      isSuccess: createToolkitFromDataIsSuccess,
      isLoading: createToolkitFromDataIsLoading,
      error: createToolkitFromDataError
    }
  ] = useCreateFormDataMutation();

  const [
    selectToolkitFromDataFunc,
    {
      data: selectToolkitFromData,
      isError: selectToolkitFromDataIsError,
      isSuccess: selectToolkitFromDataIsSuccess,
      isLoading: selectToolkitFromDataIsLoading,
      error: selectToolkitFromDataError
    }
  ] = useSelecteToolkitFormDataMutation();

  const [
    updateToolkitormDataFunc,
    {
      isError: updateToolkitormDataIsError,
      isSuccess: updateToolkitormDataIsSuccess,
      isLoading: updateToolkitormDataIsLoading,
      error: updateToolkitormDataError
    }
  ] = useUpdateToolkitFormDataMutation();

  const [getFormLibrary, { data: formData, isLoading: getFormLoading }] = useGetFormLibraryMutation();

  const [
    signToolkitformFunc,
    {
      data: signToolkitformData,
      isError: signToolkitformIsError,
      isSuccess: signToolkitformIsSuccess,
      isLoading: signToolkitformIsLoading,
      error: signToolkitformError
    }
  ] = useSignToolkitFormMutation();

  const [
    getPatientToolkitFormByIdFunc,
    {
      data: patientToolkitFormByIdData,
      isError: patientToolkitFormByIdIsError,
      isSuccess: patientToolkitFormByIdIsSuccess,
      isLoading: patientToolkitFormByIdLoading,
      error: patientToolkitFormByIdError
    }
  ] = useGetPatientToolkitFormByIdMutation();

  return {
    createToolkitFromDataFunc,
    createToolkitFromDataIsError,
    createToolkitFromDataIsSuccess,
    createToolkitFromDataIsLoading,
    createToolkitFromDataError,
    selectToolkitFromDataFunc,
    selectToolkitFromData,
    selectToolkitFromDataIsError,
    selectToolkitFromDataIsSuccess,
    selectToolkitFromDataIsLoading,
    selectToolkitFromDataError,
    getFormLibrary,
    getFormLoading,
    formData,
    updateToolkitormDataFunc,
    updateToolkitormDataIsSuccess,
    updateToolkitormDataIsError,
    updateToolkitormDataIsLoading,
    updateToolkitormDataError,
    signToolkitformFunc,
    signToolkitformData,
    signToolkitformIsError,
    signToolkitformIsSuccess,
    signToolkitformIsLoading,
    signToolkitformError,
    getPatientToolkitFormByIdFunc,
    patientToolkitFormByIdData,
    patientToolkitFormByIdIsError,
    patientToolkitFormByIdIsSuccess,
    patientToolkitFormByIdLoading,
    patientToolkitFormByIdError
  };
};
